import api from '../api';
import { GetGroupResponse } from '@ilteducation/customer-mgmt-types';
import { ref } from 'vue';

export const useGetGroup = () => {
  const group = ref<GetGroupResponse | null>(null);
  const error = ref<null | unknown>(null);
  const isLoading = ref<boolean>(false);
  const loadGroup = async (groupId: string): Promise<GetGroupResponse | null> => {
    try {
      isLoading.value = true;
      const response = await api.group.get(groupId);
      group.value = response.data;
    } catch (err: unknown) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }

    return group.value;
  };

  return {
    loadGroup,
    isLoading,
    group,
    error,
  };
};
